function VisaPurpose({ purposes = [], selectedPurpose, onSelectPurpose }) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">
        Step 3: Select Purpose
      </h3>

      {purposes.length === 0 ? (
        <p className="text-gray-500">
          No purposes available for this category
        </p>
      ) : (
        <div className="space-y-3">
          {purposes.map((purpose) => {
            const isSelected =
              selectedPurpose?.purpose_code === purpose.purpose_code;

            return (
              <label
                key={purpose.purpose_code}
                className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                  isSelected
                    ? "border-blue-600 bg-blue-50"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                {/* Radio button */}
                <input
                  type="radio"
                  name="visa-purpose"
                  checked={isSelected}
                  onChange={() => onSelectPurpose(purpose)}
                  className="mt-1 h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />

                {/* Purpose text */}
                <div className="text-sm text-gray-900 leading-snug">
                  {purpose.purpose}
                </div>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default VisaPurpose;
